declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, X_BillHeaderController, x_BillDetailsRequest, BillDetailsInfoController, X_BillItemsController, X_BillReceiptsController, SaveBillRefundsInfoRequest, RefundDetailsInfoController, RefundItemsController, RefundListController2, RefundItemsRequest, SaveRefundStatusRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbPaymentRefundModal } from './modal/paymentrefund.modal';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';




@Component({
    selector: 'refundItems',
    templateUrl: './refundItems.component.html',
    styleUrls: ['./refundItems.component.scss']
    , animations: [routerTransition()]
})

export class RefundItemsComponent implements OnInit {


    public ApiResData: ApiResponseModel;
    @Input() FormattedCode: string;

    public ActorCode: number = 0;
    //public FormattedCode: number = 0;
    public isNew: boolean = false;
    public isEdit: boolean = false;
    public IsExpand: boolean = true;
    public Showarrow: boolean = false;
    public ShowList: boolean = true;
    public ShowPatientDetails: boolean = false;
    public receipt: boolean = true;
    public opbilling: boolean = false;
    public Add: boolean = true;
    public Edit: boolean = false;
    public LChargeEntryCode: number = 0;
    public Tdiscount: number;
   // public Tdiscount: number = 0;
    public isRequesting: boolean = false;
    public PrescriberData: PrescribingDoctor[];
    public ReferalData: ReferringDoctor[];
    public cash: boolean = false;
    public card: boolean = false;
    public cheque: boolean = false;
    public demanddraft: boolean = false;
    public ChargeEntryCode: any;
  public RequestMode: any;
  RefundRequestStatus: any;
    public RefundStatus: any;
    public paytm: boolean = false;
    public FormattedCodedata: any;
    public RefundCode: any;
    public SelectedDay: any;
    public SelectedMonth: any;
    public SelectedYear: any;
    SelectedFromDate: NgbDateStruct;
    public Prescribername: any;
    public Prescribercode: any;
    public Prescriberdesg: any;
    public Referalname: any;
    public ReferalCode: any;
    public Referaldesg: any;
    public TotalBill: number;
    public TotalRefund: number=0;
    public NetPayable: number;
    public BranchName: string;
    public Date: Date;
  public Comments: string;
  public BillTotal: any;
  public Discount: any;
  public NetPaid: any;
    public ChargeEntryCodeModal: number = 0;
    searchTitle: string;
   // public SelectedPrescriber: PrescribingDoctor[];
    //public SelectedReferral: ReferringDoctor[];
    CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
    CurrentSaveBillRefundsInfoRequest: SaveBillRefundsInfoRequest;
    CurrentSaveRefundStatusRequest: SaveRefundStatusRequest;
    CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
    SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
    CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



    LoadPatients(FormattedCode: string) {
        this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

        //alert('Reing Forma ' + this.FormattedCode);



        this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

        this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
        this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
        this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
        this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
        this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
        this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
        this.GetPatientInfoByFormattedCodeController();
    }
    GetPatientInfoByFormattedCodeController() {
        this.StartRefreshing();


        this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
                    this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
                    //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    //this.LoadSign();
                    //this.LoadPatientCounsellingPlansIfAny();



                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    constructor(private router: Router,
      private actorservice: ActorService,
      public printService: PrintService,
        private route: ActivatedRoute, private loaderService: SpinnerService,
        private modalService: NgbModal,
        private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
        private filter: Servicebillpipe, private spinner: NgxSpinnerService


    ) { }

    ngOnInit() {

        this.Tdiscount = 0;
        this.TotalRefund = 0;
        this.RefundCode = this.route.snapshot.paramMap.get('RefundCode');
      this.RequestMode = this.route.snapshot.paramMap.get('RequestMode');
      this.RefundRequestStatus = this.route.snapshot.paramMap.get('RefundRequestStatus');
      this.BillTotal = this.route.snapshot.paramMap.get('BillTotal');
      this.Discount = this.route.snapshot.paramMap.get('Discount');
      this.NetPaid = this.route.snapshot.paramMap.get('NetPaid');
        this.RefundStatus = this.route.snapshot.paramMap.get('RefundStatus');
        this.BranchName = AppData.Instance().SelectedBranchName;
        this.SelectedDay = this.route.snapshot.paramMap.get('Day');
        this.SelectedMonth = this.route.snapshot.paramMap.get('month');
        this.SelectedYear = this.route.snapshot.paramMap.get('year');
        this.SelectedFromDate = { year: this.SelectedYear, month: this.SelectedMonth, day: this.SelectedDay };

        //this.LoadPatients(this.FormattedCodedata);
       // this.LoadBillHeader(this.ChargeEntryCode);
        this.LoadServicesByCategory();
        this.LoadRefItems();
       // this.LoadDoctorPres();
        this.LoadDoctorRef();
        this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
        this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentSaveRefundStatusRequest = new SaveRefundStatusRequest();
        this.CurrentSaveRefundStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentSaveBillRefundsInfoRequest = new SaveBillRefundsInfoRequest();
        this.CurrentSaveBillRefundsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    }
    CurrentX_BillHeaderController: X_BillHeaderController;
    CurrentX_BillItemsController: X_BillItemsController[];
    CurrentX_BillReceiptsController: X_BillReceiptsController[];
    //FollicularScanEndInfo: FollicularScanDetailController;
    // BillHeader: X_BillHeaderController[];
    CurrentX_BillHeaderRequest: x_BillDetailsRequest;

    BillDataHeader: BillDetailsInfoController;
    CurrentRefundItemsController: RefundItemsController[];
    CurrentRefundListController2: RefundListController2;
    RefundData: RefundDetailsInfoController;
    CurrentRefundItemsRequest: RefundItemsRequest;
    LoadRefItems() {
        //alert("ScansData")
        this.CurrentRefundItemsRequest = new RefundItemsRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentRefundItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetRefundDetailsInfoController();
    }

    GetRefundDetailsInfoController() {
        //this.StartRefreshing();

        this.CurrentRefundItemsRequest.RefundCode = this.RefundCode;
        this.CurrentRefundItemsRequest.Branch = AppData.Instance().SelectedBranchCode;
        this.CurrentRefundItemsRequest.ConditionalOperator = 10;
        this.CurrentRefundItemsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
        this.CurrentRefundItemsRequest.ToDate = new Date();
        // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
        //this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
        //this.Cu
        //alert(this.FormattedCode);

        this.actorservice.RefundDetailsInfoController(this.CurrentRefundItemsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.RefundData = this.ApiResData.Result;
                    this.CurrentRefundListController2 = this.RefundData.RefundHeader;
                    this.CurrentRefundItemsController = this.RefundData.RefundItems;
                   this.LoadPatients(this.CurrentRefundListController2.PatientFormattedCode);
                    //this.AddData2();
                    // this.ChargeEntryCode = this.CurrentX_BillHeaderController[0].ChargeEntry;
                    //alert(this.CurrentX_BillHeaderController[0].PatientName);
                    //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
                    // this.CurrentX_BillHeaderController[0].PatientName;
                    //alert(this.CurrentX_BillHeaderController);
                    //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    AddData2() {

      
        this.CurrentBillDetails = new Array<BillDetails>();
        this.CurrentRefundItemsController.forEach((v, i, d) => {
            var item = new BillDetails();
            item.Edit = false;
            item.RowNumber = item.RowNumber + 1;
            item.ServiceDescription = v.ItemDescription;
            item.Quantity = v.Quantity;
            item.Discount = v.Discount;
            item.UnitPrice = v.UnitPrice;
            item.ItemRate = v.ItemTotal;
            item.GroupName = v.ServiceCategoryCode.toString();
            item.PackageName = v.ServiceCategoryName;
            item.DiscountAllowed = false;
            item.ChargeItemCode = v.PatientChargeItem;
            item.ItemCode = v.ItemCode;
            item.RefundQuantity = v.RefundQuantity;
            item.RefundableAmount = 0;
            this.CurrentBillDetails.push(item);

        });

        this.TotalBill = 0;
        this.NetPayable =0;
        this.Tdiscount = 0;
        this.BranchName = AppData.Instance().SelectedBranchName;
        this.Date = new Date();
        this.LChargeEntryCode = this.CurrentRefundListController2.ChargeEntry;

        this.Payment();
    }
    Payment() {
        const modalRef = this.modalService.open(NgbPaymentRefundModal,
            {
                centered: true,
                size: "lg"

            })
        modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
        modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
        modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
        modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
        modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
        modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
      modalRef.componentInstance.BillDate = new Date();
      modalRef.componentInstance.TotalBill = this.BillTotal;
      modalRef.componentInstance.NetPayable = this.NetPaid;
      modalRef.componentInstance.Discount = this.Discount;
        modalRef.componentInstance.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode;
        modalRef.componentInstance.ChargeEntryCode = this.LChargeEntryCode;
        modalRef.componentInstance.BillStatus = "";
        modalRef.componentInstance.BillType = this.CurrentRefundListController2.BillType;
        modalRef.componentInstance.BillSource = "";
        modalRef.componentInstance.BranchName = AppData.Instance().SelectedBranchName;
        modalRef.componentInstance.BranchCode = AppData.Instance().SelectedBranchCode;
        modalRef.componentInstance.CompanyCode = this.CurrentRefundListController2.RefundCode;
        modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;
        modalRef.componentInstance.TotalRefund = this.CurrentRefundListController2.ApprovedAmount;
        modalRef.componentInstance.Prescriber = this.CurrentPrescribingDoctor;
        modalRef.componentInstance.Refferal = this.CurrentReferringDoctor;
        modalRef.result.then((val: number) => {
            this.ChargeEntryCodeModal = val;
        });
        modalRef.result.then(x => { this.GetRefundDetailsInfoController() })
    }
    CurrentServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
    CurrentServicesByCategoryCodeController: ServicesByCategoryCodeController[];
    LoadServicesByCategory() {

        this.CurrentServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
        //this.pdata2 = this.ServicesByCategoryCodeController;
        this.CurrentServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentServicesByCategoryCodeGetRequest.ServiceCategory = "0";
        this.CurrentServicesByCategoryCodeGetRequest.BranchCode = AppData.Instance().SelectedBranchCode;
        this.CurrentServicesByCategoryCodeGetRequest.ConditionalOperator = 10;
        this.CurrentServicesByCategoryCodeGetRequest.PrescriberCode = this.Prescribercode;
        this.CurrentServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
        this.pdata = this.CurrentServicesByCategoryCodeController;
        this.GetServicesByCategoryCodeController();

    }
    GetServicesByCategoryCodeController() {
        this.StartRefreshing();
        this.actorservice.GetServicesByCategoryCodeController(this.CurrentServicesByCategoryCodeGetRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                    this.CurrentServicesByCategoryCodeController = this.ApiResData.Result;
                    this.pdata = this.CurrentServicesByCategoryCodeController;

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    
    CurrentPrescribingDoctor: Array<PrescribingDoctor>;
    LoadDoctorPres() {
        if (this.CurrentPrescribingDoctor == null) {
            this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();
        }
        if (this.CurrentPrescribingDoctor != null) {
            var row = new PrescribingDoctor();
            row.DoctorName = this.CurrentX_BillItemsController[0].PrescriberName
            row.DoctorCode = this.CurrentX_BillItemsController[0].Prescriber;
            row.Designation = "";
            this.CurrentPrescribingDoctor.push(row);
        }
    }

    CurrentReferringDoctor: Array<ReferringDoctor>;

    LoadDoctorRef() {
        if (this.CurrentReferringDoctor == null) {
            this.CurrentReferringDoctor = new Array<ReferringDoctor>();
        }
        if (this.CurrentReferringDoctor != null) {
            var row = new ReferringDoctor();
            row.DoctorName = this.Referalname;
            row.DoctorCode = this.ReferalCode;
            row.Designation = this.Referaldesg;
            this.CurrentReferringDoctor.push(row);
        }
    }

    BackToProfile() {
        this.ShowList = true;
        this.ShowPatientDetails = false;
        this.Showarrow = false;
    }
    cashdata() {
        this.cash = true;
    }
    carddata() {
        this.card = true;
    }
    chequedata() {
        this.cheque = true;
    }
    demanddraftdata() {
        this.demanddraft = true;
    }
    paytmdata() {
        this.paytm = true;
    }
    pdata: any[];// = this.data;
    listFilter: string;
    ngOnChanges(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata = this.CurrentServicesByCategoryCodeController;

        this.criteriaChange(this.listFilter);
    }
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentServicesByCategoryCodeController,
                    this.listFilter);
            }
        }
    }

    clearData() {
        this.isNew = true;
        this.ShowList = false;

    }
    ExpandData() {
        if (this.IsExpand === true) {
            this.IsExpand = false;
        }
        else {
            this.IsExpand = true;
        }
    }

    //docedit() {

    //    const modalRef = this.modalService.open(NgbAddBill,
    //        {
    //            centered: true,
    //            size: "lg",
    //            backdrop: 'static',
    //            keyboard: false
    //        })
    //    modalRef.componentInstance.FormattedCode = this.FormattedCodedata;
    //    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
    //        this.SelectedPrescriber = receivedEntry.make;
    //        this.SelectedReferral = receivedEntry.value;
            
    //       alert(this.ProvidedName);
    //    })


    //}
    CancelNewOperation() {

        this.ShowList = true;
    }
    back() {
        this.receipt = false;
        this.opbilling = true;
        this.router.navigate(['/healins/opbilling']);
        //this.router.navigate.['/healins/opbilling'];
    }
    payment() {
        const modalRef = this.modalService.open(NgbPayBillModal,
            {
                centered: true,
                size: "lg"
            })
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    deletedBillDetails: Array<BillDetails> = new Array<BillDetails> ();
    CurrentBillDetails: Array<BillDetails>;
    AddRow(l: ServicesByCategoryCodeController) {
        if (this.CurrentBillDetails == null) {
            this.CurrentBillDetails = new Array<BillDetails>();
        }

        // check if items is in deleted items list.. if exists.. remove from there.. and add to current list..
 

            var item = this.deletedBillDetails.find(x => x.ServiceDescription == l.ServiceName);
        if (item != null) {
            this.CurrentBillDetails.push(item);
            this.deletedBillDetails.splice(this.deletedBillDetails.findIndex(x => x.ServiceDescription == l.ServiceName), 1);
        }

        else // items does not exist in detled items buckeet.
        {

            var row = new BillDetails();
            row.Edit = false;
            row.RowNumber = row.RowNumber + 1;
            row.ServiceDescription = l.ServiceName;
            row.Quantity = 1;
            row.Discount = 0;
            row.UnitPrice = l.BasePrice;
            row.ItemRate = l.BasePrice * row.Quantity;
            row.GroupName = l.Servicecategory;
            row.PackageName = l.CategoryName;
            row.DiscountAllowed = l.DiscountAllowed;
            row.ChargeItemCode = 0;
            row.ItemCode = l.Code;
            this.CurrentBillDetails.push(row);

        }
        

        this.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
            .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current);

        this.NetPayable = this.CurrentBillDetails.filter((item) => item.ItemRate)
            .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current) - this.Tdiscount;
       
        this.Date = new Date();
        //        alert(l.BasePrice);

        //this.AddData();

    }
    //CurrentBillDetails: Array<BillDetails>;
   
    CurrentNewBillData: NewBillData;
    AddData() {
        this.CurrentNewBillData = new NewBillData();
        this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;
        this.CurrentNewBillData.BillDate = new Date();
        this.CurrentNewBillData.BillSource = "Internal";
        this.CurrentNewBillData.BillStatus = "";
        this.CurrentNewBillData.BillType = "OP";
        this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
        this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
        this.CurrentNewBillData.ChargeEntryCode = this.LChargeEntryCode;
        this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
        this.CurrentNewBillData.Items = this.CurrentBillDetails;
        this.CurrentNewBillData.DeletedItems = this.deletedBillDetails;
        this.CurrentNewBillData.PrescriberDoctor = this.CurrentPrescribingDoctor;
        this.CurrentNewBillData.ReferringDoctor = this.CurrentReferringDoctor;
        this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
        this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
        this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
        this.CurrentNewBillData.TotalDiscount = this.Tdiscount;
        this.CurrentNewBillData.TotalRefund = this.TotalRefund;
        this.CurrentNewBillData.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
           .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current);
        this.CurrentNewBillData.NetPayable = this.CurrentBillDetails.filter((item) => item.ItemRate)
            .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current) - this.Tdiscount;

        //this.CurrentNewBillData
        this.SaveData();
       

    }
    SaveData() {
        this.spinner.show();
        this.CurrentSaveBillRefundsInfoRequest.Refund = this.CurrentNewBillData;
        this.CurrentSaveBillRefundsInfoRequest.ChargeEntry = this.LChargeEntryCode;
        this.CurrentSaveBillRefundsInfoRequest.ConditionalOperator = 10;
        this.actorservice.SaveBillRefundsInfo(this.CurrentSaveBillRefundsInfoRequest)
            .subscribe((result) => {

                this.ApiResData = result;
                if (result.Result > 0) {
                //if (!this.ApiResData.hasError) {

                 //   if (this.ApiResData.Result > 0) {
                        this.LChargeEntryCode = this.ApiResData.Result[0].Result;
                       // alert(this.LChargeEntryCode);
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                       // this.Listview = true;
                        //this.EditEmbryo = false;
                        //this.LoadStoreData();
                        //this.AddEmbryo = false;
                        //this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation :- " + "...!");

                        //this.spinner.hide();
                        this.stopRefreshing();
                        this.spinner.hide();
                    }

                },
                
                
            


                (error) => {
                   // alert("kkhkhjkhkjhjkh");

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                       this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                       this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
    Qunatitychange(l: BillDetails) {

       
        l.ItemRate = l.Quantity * l.UnitPrice;
        this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
            .map((l) => +l.ItemRate)
            .reduce((sum, current) => sum + current);
      // l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);

        //this.Tdiscount = this.CurrentBillDetails.filter((l) => l.rDiscount)
          //  .map((l) => +l.rDiscount)
           // .reduce((sum, current) => sum + current);
        this.NetPayable = this.TotalBill - this.Tdiscount;

    }
    Qunatitychange2(l: BillDetails) {
        l.ItemRate = l.RefundQuantity * l.UnitPrice;
        this.TotalRefund = this.CurrentBillDetails.filter((l) => l.ItemRate)
            .map((l) => +l.ItemRate)
            .reduce((sum, current) => sum + current);
    }
    Discountchange(l: BillDetails) {


        l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);
        
        this.Tdiscount = this.CurrentBillDetails.filter((l) => l.rDiscount)
            .map((l) => +l.rDiscount)
           .reduce((sum, current) => sum + current);
        this.NetPayable = this.TotalBill - this.Tdiscount;
    }
    CheckedBillDetails: Array<BillDetails> = new Array<BillDetails>();
    CheckRefund(l: BillDetails,e) {
        var statusVal = e.target.checked;
        if (statusVal == true) {
           // alert("Step1");
            l.RefundQuantity = 1;
            l.ItemRate = l.RefundQuantity * l.UnitPrice;
            this.CheckedBillDetails = this.CurrentBillDetails.filter(
                function (a) {
                    return a.IsSelected == true

                }
            );
            this.TotalRefund = this.CheckedBillDetails.filter((l) => l.ItemRate)
                .map((l) => +l.ItemRate)
                .reduce((sum, current) => sum + current);
        }
        else if (statusVal == false) {
            this.CheckedBillDetails = null;
            l.RefundQuantity = 0;
            l.ItemRate = l.RefundQuantity * l.UnitPrice;
            this.CheckedBillDetails = this.CurrentBillDetails.filter(
                function (a) {
                    return a.IsSelected == true

                }
            );
            this.TotalRefund = this.CheckedBillDetails.filter(l => l.ItemRate)
                .reduce((sum, current) => sum + current.ItemRate, 0);
           
            //if (this.CurrentBillDetails.length = 1) {
            //    l.RefundQuantity = 0;
            //    l.ItemRate = l.RefundQuantity * l.UnitPrice;
            //    this.TotalRefund = 0;
            
            //}
            //else if (this.CurrentBillDetails.length>1) {
            //    l.RefundQuantity = 0;
            //    l.ItemRate = l.RefundQuantity * l.UnitPrice;
            //    this.TotalRefund = this.CurrentBillDetails.filter((l) => l.ItemRate)
            //        .map((l) => +l.ItemRate)
            //        .reduce((sum, current) => sum + current);
               
            //}
        }
    }

    //alert(this.CurrentBillDetails.length);
    // CurrentBillDetailsEdit: BillDetails;
    Editrow(l: BillDetails) {
        //this.Add = false;

        //this.Edit = true;
        l.Edit = true;
        //this.CurrentBillDetailsEdit = new BillDetails();
        //this.CurrentBillDetailsEdit.rownumber = l.rownumber;
        //this.CurrentBillDetailsEdit.ServiceDescription = l.ServiceDescription;
        //this.CurrentBillDetailsEdit.quantity = l.quantity;
        //this.CurrentBillDetailsEdit.unitprice = l.unitprice;
        //this.CurrentBillDetailsEdit.discount = l.discount;
        //this.CurrentBillDetailsEdit.ItemRate = l.ItemRate;

    }
    delete(i: number, l: BillDetails) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            this.deleterow(i,l);

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })

    }
    CancelRefund() {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            this.Cancel();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })

    }
    Cancel() {
        this.CurrentSaveRefundStatusRequest.RefundCode = this.RefundCode;
      this.CurrentSaveRefundStatusRequest.RefundReason = "Cancel";
      this.CurrentSaveRefundStatusRequest.RefundStatus = "Cancel";
        this.CurrentSaveRefundStatusRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveRefundStatusRequest.ConditionalOperator = 30;
        this.actorservice.SaveRefundStatus(this.CurrentSaveRefundStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                  if (this.ApiResData.Result[0].Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                    this.Back();
                        this.spinner.hide();                        
                        //this.activeModal.close();


                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    Approve() {
        this.CurrentSaveRefundStatusRequest.RefundCode = this.RefundCode;
        this.CurrentSaveRefundStatusRequest.RefundReason = this.Comments;
        this.CurrentSaveRefundStatusRequest.RefundStatus = "Approve";
        this.CurrentSaveRefundStatusRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveRefundStatusRequest.ConditionalOperator = 10;
        this.actorservice.SaveRefundStatus(this.CurrentSaveRefundStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (result.Result[0].Result > 0) {
                   
                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                    this.LoadRefItems();
                    //this.router.navigate(['healins/refundslist']);
                  
                    this.stopRefreshing();
                    this.spinner.hide();
                }
                else {
                    alertFunctions.AlertParam("Invalid Operation :- " + "...!");

                    //this.spinner.hide();
                    this.stopRefreshing();
                    this.spinner.hide();
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    Reject() {
        this.CurrentSaveRefundStatusRequest.RefundCode = this.RefundCode;
        this.CurrentSaveRefundStatusRequest.RefundReason = this.Comments;
        this.CurrentSaveRefundStatusRequest.RefundStatus = "Reject";
        this.CurrentSaveRefundStatusRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveRefundStatusRequest.ConditionalOperator = 20;
        this.actorservice.SaveRefundStatus(this.CurrentSaveRefundStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (result.Result[0].Result > 0) {

                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                    this.LoadRefItems();
                    //this.router.navigate(['healins/refundslist']);

                    this.stopRefreshing();
                    this.spinner.hide();
                }
                else {
                    alertFunctions.AlertParam("Invalid Operation :- " + "...!");

                    //this.spinner.hide();
                    this.stopRefreshing();
                    this.spinner.hide();
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    deleterow(i: number, l: BillDetails) {
        this.CurrentBillDetails.splice(i, 1);

        // put this in deteleted items list...
        this.deletedBillDetails.push(l);

        this.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
            .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current);

        this.Discountchange(l);

    }
    OnClear(l: BillDetails) {
        l.Edit = false;
    }
   
    Back() {
        this.router.navigate(['healins/refundslist']);
    }
    //Cancel() {
    //   this.router.navigate(['healins/opbilling']);
    //}
  refundbill() {
    //alert("hello");
    this.printService.printDocument("refundbill",
      {
        ChargeEntryData: this.LChargeEntryCode, PatientId: this.SelectedPatientFormattedCode.FormattedCode, Owner: this.SelectedPatientFormattedCode.DisplayName, Gender: this.SelectedPatientFormattedCode.Gender, Age: this.SelectedPatientFormattedCode.Age, BillDate: this.CurrentNewBillData.BillDate,
        RefundData: this.TotalRefund, Branch: this.CurrentNewBillData.BranchName, GrandTotal: this.CurrentNewBillData.TotalBill, Discount: this.CurrentNewBillData.TotalDiscount, Net: this.CurrentNewBillData.NetPayable, ReferralData: this.CurrentNewBillData.ReferringDoctor,

      },

    );
  }

}
//export class BillDetails {
//    public ItemCode: number;
//    public ServiceDescription: string;
//    public Quantity: number;
//    public UnitPrice: number;
//    public Discount: number;
//    public ItemRate: number;
//    public RowNumber: number;
//    public Edit: boolean;
//    public ServiceCode: number;
//    public ItemType: string;
//    public ItemGroup: string;
//    public GroupName: string;
//    public IsPackage: boolean;
//    public PackageName: string;
//    public ChargeItemCode: number;
//    public DiscountAllowed: boolean;
//    public rDiscount: number;
//    public IsSelected: boolean;
//    public RefundQuantity: number;
//    public EditableCharge: boolean;
//  public RefundableAmount: number;
//  public RefundableQuantity: number;
//  public TaxPercentage: number;
//}
//export class PrescribingDoctor {
//    public DoctorName: string;
//    public DoctorCode: number;
//    public Designation: string;
//}
//export class ReferringDoctor {
//    public DoctorName: string;
//    public DoctorCode: number;
//    public Designation: string;
//}

